
define('template!ordersDetailSupplierEditInvoiceProductionSheetView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="canvas-ctn">\n</div>\n';

}
return __p
};});

